import styles from './company-requests-grid.module.scss';
import { useState } from 'react';
import { ValueFormatterParams } from 'ag-grid-community';
import { booleanHeader, CreateHeaders, dateHeader, HeaderSizeEnum, PrimaryButton, textHeader } from '@frontend-workspace/react-shared-lib';
import CompanyDialogContent from '../company-dialog/company-dialog';
import { INewCompanyRequest } from '../../_models/new-company-request';
import WebkuaTable from '../../webkua-table/webkua-table';
import { useTranslation } from 'react-i18next';
import { booleanFormatter } from '../../helpers';
import { useMakeRequestHook } from '../../requestUtils';

/* eslint-disable-next-line */
export interface CompanyRequestsGridProps {
  companyRequests: INewCompanyRequest[],
  getCompanyRequests: () => void
}

export function CompanyRequestsGrid(props: CompanyRequestsGridProps) {
  const { t } = useTranslation();
  const makeRequest = useMakeRequestHook();
  const [company, setCompany] = useState<INewCompanyRequest | undefined>(undefined);

  const openCompanyDialog = (e: any) => setCompany(e.data);
  const closeCompanyDialog = () => setCompany(undefined);

  const companyRenderer = (params: ValueFormatterParams) => (
    <PrimaryButton
      variant="outlined"
      size='small'
      onClick={() => openCompanyDialog(params)}>
      {t("standard.processRequest")}
    </PrimaryButton>
  );
  const chooseSellerRenderer = (params: ValueFormatterParams) => {
    const chooseSellerForRequest = () => makeRequest(`admin/action/SetMeAsContactForRequest`, 'PUT', { orderId: params.value }).then(result => {
      props.getCompanyRequests();
    });
    return <PrimaryButton
      variant="outlined"
      size='small'
      onClick={chooseSellerForRequest}>
      {t("companyRequest.chooseFollowUpSeller")}
    </PrimaryButton>
  };

  const headers = CreateHeaders([
    textHeader("companyName", t("standard.companyName"), HeaderSizeEnum.MEDIUM),
    textHeader("orgNr", t("standard.organisationNumber"), HeaderSizeEnum.MEDIUM),
    textHeader("firstName", t("standard.adminFirstName"), HeaderSizeEnum.LARGE),
    textHeader("lastName", t("standard.adminLastName"), HeaderSizeEnum.MEDIUM),
    textHeader("userAddedInfo", t("companyRequest.userAddedInfo")),
    textHeader("country", t("companyRequest.country")),
    dateHeader("requestDate", t("standard.date")),
    textHeader("sellerName", t("companyRequest.followUpSellerName"), HeaderSizeEnum.MEDIUM),
    textHeader("id", "", HeaderSizeEnum.MEDIUM, { renderer: chooseSellerRenderer }),
    textHeader("", "", HeaderSizeEnum.MEDIUM, {
      renderer: companyRenderer,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
  ])

  return <>
    <WebkuaTable
      headers={headers}
      data={props.companyRequests}
    />
    {company &&
      <CompanyDialogContent
        open={!!company}
        onClose={closeCompanyDialog}
        company={company}
      />}
  </>;
}

export default CompanyRequestsGrid;